export var AudioPlayback;
(function (AudioPlayback) {
    AudioPlayback["NoSync"] = "nosync";
    AudioPlayback["Pitch"] = "pitch";
    AudioPlayback["Timestretch"] = "timestretch";
    AudioPlayback["AudioFit"] = "audiofit";
})(AudioPlayback || (AudioPlayback = {}));
